import { MainMap } from '@old/features/map/map';

export function MapPage() {
  return <MainMap />;
}
